import { useContext } from "react";

import { PlayerStoreContext } from "./store";

export const usePlayerStore = () => {
  const store = useContext(PlayerStoreContext);
  if (!store) {
    throw new Error("Missing PlayerStoreContext.Provider in the tree");
  }
  return store;
};
